import React, { forwardRef } from 'react';
import { defaultGraphFont } from 'styles/styleUtils';

const SVGText = forwardRef<SVGTextElement, React.ComponentPropsWithoutRef<'text'>>((props, ref) => (
  <text fontFamily={defaultGraphFont} ref={ref} {...props} />
));

export default SVGText;
